module.exports = __webpack_public_path__ + "static/grafika11@2x-004e8fbe508304fbb5687dc0d7f1d581.png";